import * as React from "react";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkSheet, UitkSheetContent } from "uitk-react-sheet";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from "uitk-react-menu";
import { UitkToolbar, UitkToolbarProps } from "uitk-react-toolbar";
import { UitkSpacing } from "uitk-react-spacing";
import { AdaptiveMenuDialogTrigger } from "./AdaptiveMenuDialogTrigger";

export interface AdaptiveMenuDialogProps {
  dialogWrapper: (children: any) => JSX.Element;
  showAdaptive: boolean;
  menuPosition?: PositionType;
  adaptiveTrigger?: () => JSX.Element;
  toolbar?: UitkToolbarProps;
  children?: React.ReactElement;
  handleMenuClick?: (e?: any, eventData?: any) => void;
  handleMenuDismiss?: (e?: any, eventData?: any) => void;
  handleDialogClick?: (e?: any, eventData?: any) => void;
}

export class AdaptiveMenuDialog extends React.PureComponent<AdaptiveMenuDialogProps> {
  constructor(props: AdaptiveMenuDialogProps) {
    super(props);

    this.renderDialog = this.renderDialog.bind(this);
    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleMenuDismiss = this.handleMenuDismiss.bind(this);
  }

  public renderDialog(): JSX.Element {
    const { children, showAdaptive, toolbar } = this.props;
    return (
      <UitkSheet type="full" isVisible={showAdaptive} triggerRef={React.createRef<HTMLElement>()}>
        {toolbar && <UitkToolbar {...toolbar} />}
        <UitkSheetContent>{children}</UitkSheetContent>
      </UitkSheet>
    );
  }

  public handleMenuClick(event: React.MouseEvent) {
    if (this.props.handleMenuClick) {
      this.props.handleMenuClick(event);
    }
  }

  public handleMenuDismiss() {
    if (this.props.handleMenuDismiss) {
      this.props.handleMenuDismiss();
    }
  }

  public renderMenu(props: AdaptiveMenuDialogProps): JSX.Element {
    const { adaptiveTrigger, menuPosition, showAdaptive } = props;

    return (
      <UitkMenu
        id="adaptive-menu"
        isOpen={showAdaptive}
        onTriggerClick={this.handleMenuClick}
        onDismiss={this.handleMenuDismiss}
      >
        <UitkMenuTrigger>{adaptiveTrigger!()}</UitkMenuTrigger>
        <UitkMenuContainer autoPosition={true} position={menuPosition} width={376}>
          <UitkSpacing padding="three">
            <div>{this.props.children}</div>
          </UitkSpacing>
        </UitkMenuContainer>
      </UitkMenu>
    );
  }

  public render() {
    const { dialogWrapper, handleDialogClick, adaptiveTrigger } = this.props;

    return (
      <div>
        <Viewport>
          <ViewSmall>
            <React.Fragment>
              {dialogWrapper(this.renderDialog())}
              <AdaptiveMenuDialogTrigger onClick={handleDialogClick} trigger={adaptiveTrigger!()} />
            </React.Fragment>
          </ViewSmall>
          <ViewLarge>{this.renderMenu(this.props)}</ViewLarge>
        </Viewport>
      </div>
    );
  }
}
